import { Stack } from '@chakra-ui/react'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { LEADERBOARD_TIME_FRAMES, VISIBLE_LEADERBOARD_KEYS } from '@/client/services/leaderboard'

import UserBadgesCount from '@/components/Achievements/UserBadgesCount'
import UserPointsTotal from '@/components/Achievements/UserPointsTotal'
import LeaderboardHighlightDisplay from '@/components/Leaderboard/LeaderboardHighlightDisplay'
import useLeaderboardHighlight from '@/components/Leaderboard/useLeaderboardHighlight'

export default function ProfileAchievementHighlights({ user }: { user: Query }): JSX.Element {
  const userId = user(UserQ.id) ?? 0

  const leaderboardHighlight = useLeaderboardHighlight({
    keys: VISIBLE_LEADERBOARD_KEYS,
    timeFrames: LEADERBOARD_TIME_FRAMES,
    userId,
  })

  return (
    <Stack direction="column" spacing={4}>
      <UserPointsTotal user={user} variant="big" />
      <UserBadgesCount user={user} variant="big" />
      <LeaderboardHighlightDisplay highlight={leaderboardHighlight} />
    </Stack>
  )
}
